<template>
  <div class="BaseDisButton">
    <div class="btn">
      <button
        :type="type"
        @click="$emit('click')"
      >
        <slot />
      </button>
      <p> {{ value }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseDisButton',
  props: {
    type: {
      type: String,
      default: 'button',
    },
    value: {
      type: String,
      default: undefined,
    },
  },
};

</script>

<style lang="scss" scoped>


.BaseDisButton {

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    width: 35px;
    background-color: var(--color-primary-light);
    font-size: .5rem;
    color: white;
    border: none;
    border-radius: 50%;
    margin: 0 auto;
    &:hover{
      cursor: pointer;
    }
  }

  button:active{
    background-color: darken(hsl(209, 87%, 38%), 10%);
  }
}
</style>
